import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  OneToMany,
  PrimaryGeneratedColumn
} from 'typeorm';
import { Endereco } from './Endereco';
import Pedido from './Pedido';

@Entity()
export class Cliente {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  nome: string = '';

  @Column()
  email: string = '';

  @Column({ select: false })
  senha: string = '';

  @Column({ default: 0 })
  nivel: number = 0;

  @Column({ default: '' })
  pushToken?: string;

  @Column({ unique: true, length: 11 })
  celular: string = '';

  @Column()
  verificado: boolean = false;

  @Column({ select: false })
  verificacaoCodigo: number = 0;

  @Column({ select: false })
  verificacaoTentativas: number = 0;

  @Column({ select: false })
  verificacaoTotalTentativas: number = 0;

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;

  @OneToMany(() => Endereco, (endereco: Endereco) => endereco.cliente, {
    cascade: true,
    eager: true
  })
  enderecos?: Endereco[];

  @OneToMany(() => Pedido, (pedido: Pedido) => pedido.cliente)
  pedidos!: Pedido[];
}

export default Cliente;
